import React from 'react'
import { type Control } from 'react-hook-form'
import { Divider, Stack } from '@mui/material'
import StrategyComponentParameterCard from './strategy-component-parameter-card'
import { type StrategyComponentFormInputs } from './strategy-component-card'
import { type IStrategyComponent } from '../../../models/strategy/strategy-component-types'

interface StatelessParametersDisplayProps {
  processedParameters: Record<string, string | number | boolean>
  strategyName: string
  strategy: IStrategyComponent
  control: Control<StrategyComponentFormInputs>
}

const StatelessParametersDisplay: React.FC<StatelessParametersDisplayProps> = ({
  strategyName, processedParameters, strategy, control
}) => {
  // Parameters that do not require state / form management
  const statelessParameters = Array.from(new Set(Object.keys(processedParameters)
    .filter(parameter => !parameter.includes('.'))))

  if (statelessParameters?.length === 0) {
    return null
  } else {
    return (
      <Stack
        direction='row'
        gap={1}
        divider={<Divider orientation='vertical' flexItem/>}
        sx={{ overflowX: 'auto' }}
        paddingBottom={1}
      >
        {
          statelessParameters?.map((state) => {
            return (
              <Stack
                gap={1}
                key={state}
                paddingTop={1}
              >
                {
                  Object.entries(processedParameters ?? [])
                    .filter(([parameter, value]) => {
                      return state === parameter
                    })
                    .map(([parameter, value]) =>
                      <StrategyComponentParameterCard
                        key={`${strategyName}.${parameter}`}
                        name={`${strategyName}.${parameter}`}
                        control={control}
                        strategy={strategy}
                        parameter={parameter}
                        value={value}
                      />
                    )
                }
              </Stack>
            )
          })
        }
      </Stack>
    )
  }
}

export default StatelessParametersDisplay
